
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sexleketoy/sexhuske",
      function () {
        return require("private-next-pages/sexleketoy/sexhuske/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sexleketoy/sexhuske"])
      });
    }
  